import React, { Fragment } from 'react'

import s from './BrandsByAlphabet.scss'


const BrandsByAlphabet = ({ items }) => (
  <div className={s.brands}>
    {
      items.map(([ letter, links ]) => (
        <div key={letter} className={s.group}>
          <div className={s.letter}>{letter}</div>
          <Fragment>
            {
              links.map(({ name, link }, index) => (
                <a key={index} className={s.link} href={link}>
                  {name}
                </a>
              ))
            }
          </Fragment>
        </div>
      ))
    }
  </div>
)

export default BrandsByAlphabet
